export interface AppConfiguration {
  server: ServerConfiguration;
}

export interface BrandConfiguration {
  name: string;
  theme: string;
  key: string;
  group: string;
  logoMaxHeight: string;
}

/**
 * Environment configuration interface.
 * Represents the environment configuration for the application.
 * Automatically generated from the country-based configuration.
 */
export interface EnvConfiguration {
  /**
   * Configuration for the brand.
   */
  brand: BrandConfiguration;
  /**
   * The environment in which the application is deployed.
   */
  deploymentEnv: DeployEnv;
  /**
   * The unique identifier for the account.
   */
  accountId: string;
  /**
   * @deprecated Use member settings instead
   * The country code for the account.
   */
  countryCode: DeployCountry;
}

export interface ServerConfiguration {
  baseURL: string;
}

export interface PostbackConfiguration {
  campaignId: string;
  siteUrl: string;
}

export enum CountryPhoneCode {
  TH = 66,
  PH = 63,
}

export enum DeployCountry {
  TH = "th", // Thailand
  PH = "ph", // Philippines
  ID = "id", // Indonesia
  BD = "bd", // Bangladesh
  PK = "pk", // Pakistan
  IN = "in", // India
  MX = "mx", // Mexico
  BR = "br", // Brazil
}

export enum Language {
  TH = "th", // Thai
  EN = "en", // English
  ID = "id", // Indonesian
  BN = "bn", // Bengali (Bangladesh)
  UR = "ur", // Urdu (Pakistan)
  TL = "tl", // Tagalog (Philippines)
  ES = "es", // Spanish
  PT = "pt", // Portuguese (Brazil)
  HI = "hi", // Hindi
}

export type LanguageItem = {
  code: Language;
  name: string;
  flagURL: string;
};

export enum CountryEnvKey {
  TH = "TH",
  PH = "PH",
  ID = "ID",
  BD = "BD",
  PK = "PK",
  IN = "IN",
  MX = "MX",
  BR = "BR",
}

export enum Currency {
  THB = "THB",
  PHP = "PHP",
  IDR = "IDR",
  BDT = "BDT",
  PKR = "PKR",
  INR = "INR",
  MXN = "MXN",
  BRL = "BRL",
}

export enum CurrencyDirection {
  PREFIX = "prefix",
  SUFFIX = "suffix",
}

export enum DeployEnv {
  Production = "production",
  Staging = "staging",
  Local = "local",
}
